"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.jsContext = void 0;
exports.jsContext = {
    // Fundamental objects
    String: (value) => String(value),
    Number: (value) => Number(value),
    BigInt: (value) => BigInt(value),
    Array: {
        from: Array.from.bind(Array),
        isArray: Array.isArray.bind(Array),
    },
    Date: {
        now: Date.now.bind(Date),
    },
    // Functions
    JSON: {
        stringify(value) {
            return JSON.stringify(value, (_, v) => (typeof v === 'bigint' ? v.toString() : v));
        },
        parse(value) {
            return JSON.parse(value);
        },
    },
    console: {
        // eslint-disable-next-line no-console
        log: console.log.bind(console),
        // eslint-disable-next-line no-console
        error: console.error.bind(console),
        // eslint-disable-next-line no-console
        warn: console.warn.bind(console),
        // eslint-disable-next-line no-console
        info: console.info.bind(console),
        // eslint-disable-next-line no-console
        debug: console.debug.bind(console),
    },
    parseFloat: (n) => parseFloat(n),
    parseInt: (n) => parseInt(n),
    isNaN: (n) => isNaN(n),
    isFinite: (n) => isFinite(n),
};
//# sourceMappingURL=js-context.js.map